import { Box, Typography } from "@mui/material";
import React from "react";
import PrimaryHeading from "../../../../components/@ui/headings/PrimaryHeading";
import PrimaryDesc from "../../../../components/@ui/descriptions/PrimaryDesc";
import AboutImageGird from "./AboutImageGird";
import FadeInSection from "../../../../components/@extended/containers/FeadeInSection";
import SlideInOutSection from "../../../../components/@extended/containers/SlideInOutSection";

const content = {
  title: "Who are we?",
  description:
    "Priseen® Solutions FZ-LLC is a tech startup based in Dubai Internet City, dedicated to redefining the future of business-consumer interactions through cutting-edge technology and seamless experiences.\nThe team at Priseen® is working diligently to create innovative solutions that enhance engagement and drive business growth. With a focus on user-friendly and forward-thinking approaches, the goal is to revolutionize the way businesses—specializing in Retail and F&B—connect with their customers.\nAt its core, Priseen® prioritizes innovation that strengthens consumer relationships and fuels business success. Beyond innovation, the commitment extends to sustainability, integrating eco-friendly processes and sustainable supply-chain practices to ensure technological advancement goes hand in hand with environmental responsibility.\nWhether for individuals or businesses, the goal is to empower every consumer with seamless, intelligent, and user-friendly solutions that enhance daily experiences and drive progress.",
  image: "assets/images/images/about-image-grid.png",
};
export default function About() {
  const { title, description, image } = content;

  const desc = description.split("\n");

  return (
    <SlideInOutSection>
      <Box
        component="section"
        id="about-section"
        className="section-container overflow-hidden text-primary"
      >
        <div className="section-content-container flex items-center lg:flex-row flex-col justify-center duration-1000 gap-6 md:gap-12 lg:gap-16 z-[21] lg:py-[50px]">
          {/* Image Container */}

          <Box className={`flex-2 lg:min-h-[410px] lg:min-w-[493px]`}>
            <img
              src={image}
              alt={title}
              className="w-full object-contain transition-all duration-1000 transform hover:scale-105"
            />
            {/* <AboutImageGird /> */}
          </Box>
          {/* Text Content */}
          <Box className={`flex-1 space-y-6`}>
            <PrimaryHeading size="large">{title}</PrimaryHeading>

            {desc.map((d, i) => (
              <PrimaryDesc key={i}>{d}</PrimaryDesc>
            ))}
          </Box>
        </div>
      </Box>
    </SlideInOutSection>
  );
}
